import script from "./bindSharer.vue?vue&type=script&setup=true&lang=js"
export * from "./bindSharer.vue?vue&type=script&setup=true&lang=js"

import "./bindSharer.vue?vue&type=style&index=0&id=44998c54&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44998c54"]])

export default __exports__